// CSS-variable bridge so layout code can use var(--app-bar-height) etc.
// We don't try to read iOS safe-area at runtime — instead we expose
// `env(safe-area-inset-*)` through CSS vars so existing styles can compose
// them with the fixed bar heights.
//
// Call once at app boot before render.

export const APP_BAR_HEIGHT = 64;
export const BOTTOM_NAV_HEIGHT = 56;
export const HEADER_DIVIDER_THICKNESS = 3;

export function applySafeAreaCssVars() {
    if (typeof document === 'undefined') return;
    const root = document.documentElement;
    const set = (name, value) => root.style.setProperty(name, value);
    set('--safe-area-top', 'env(safe-area-inset-top, 0px)');
    set('--safe-area-bottom', 'env(safe-area-inset-bottom, 0px)');
    set('--safe-area-left', 'env(safe-area-inset-left, 0px)');
    set('--safe-area-right', 'env(safe-area-inset-right, 0px)');
    set('--app-bar-height', `${APP_BAR_HEIGHT}px`);
    set('--bottom-nav-height', `${BOTTOM_NAV_HEIGHT}px`);
    set('--header-divider-thickness', `${HEADER_DIVIDER_THICKNESS}px`);
}
